module.exports = __webpack_public_path__ + "static/media/VC.2274a14b.jpg";